export const INVALID_DATA_ORDER = 'CI_INVALID_DATA_ORDER';

export class InvalidDataOrderStateModel {
	error?: string;
}
